import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { DisplaySpinnerContext } from "../../../context/ContextIndex";
import { DivContainer, FormDivContainer, FormListDivContainer } from "./style.module";
import { ResponsiveAppBar, setBackDropLoader } from "../../ComponentsIndex";
import { selectUser } from "../../../store/store-selector";

const FormPage = (props) => {
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const user = useSelector(selectUser);

  return (
    <>
      {props?.isLoginFlow ? (
        <>
          {setBackDropLoader(spinnerCtx.isLoading)}
          {props.children}
        </>
      ) : props.isList ? (
        <FormListDivContainer customStyle={props.customStyle}>
          <ResponsiveAppBar avatarUrl={user.userRecord.photoURL} />
          {setBackDropLoader(spinnerCtx.isLoading)}
          {props.children}
        </FormListDivContainer>
      ) : (
        <>
          <ResponsiveAppBar avatarUrl={user.userRecord.photoURL} />
          <DivContainer
            divStyle={{
              height: "calc(100vh - 20px - 0px - 64px)",
              marginTop: "20px",
              paddingTop: "64px",
            }}
          >
            {setBackDropLoader(spinnerCtx.isLoading)}
            <FormDivContainer>{props.children}</FormDivContainer>
          </DivContainer>
        </>
      )}
    </>
  );
};

export default FormPage;
